// extracted by mini-css-extract-plugin
module.exports = {"buttonHover":"termsModal_buttonHover__4TpkC"};